import { useState, useEffect } from 'react';
import { createPortal } from 'react-dom';

const CHICTemplate = ({ name, thumbnail, description, label, website }) => {
    const [showDetails, setShowDetails] = useState(false);

    useEffect(() => {
        if (showDetails) {
            document.body.style.overflow = 'hidden';
        } else {
            document.body.style.overflow = 'unset';
        }
        return () => {
            document.body.style.overflow = 'unset';
        };
    }, [showDetails]);

    return (
        <>
            <div className="w-full h-[350px] flex flex-col py-[20px] bg-[#f0f0f0] items-center">
                <div
                    className="w-[200px] 1.5xl:w-[300px] h-[200px] 1.5xl:h-[300px] bg-white bg-contain bg-no-repeat bg-center border-b-[2px] border-[#b03b8a]"
                    style={{ backgroundImage: `url(${thumbnail})` }}
                />

                <div className="mt-[24px] w-[200px] 1.5xl:w-[300px] flex flex-col items-center">
                    <h3 className="w-full text-center text-[#505050] 1.5xl:text-[18px] font-proximanova font-[700]">
                        {name}
                    </h3>

                    {label && (
                        <span className="mt-[4px] text-[12px] 1.5xl:text-[14px] font-proximanova font-[700] text-[#b03b8a] px-3 py-1 rounded-full">
                            {label}
                        </span>
                    )}

                    <button
                        className="mt-[8px] text-center 1.5xl:text-[18px] font-proximanova font-[700] text-charmOrange underline hover:text-[#d94f1a] transition-colors"
                        onClick={() => setShowDetails(true)}
                    >
                        Learn more
                    </button>
                </div>
            </div>

            {showDetails && createPortal(
                <div
                    className="fixed inset-0 bg-transparent bg-opacity-10 flex items-center justify-center p-4 backdrop-blur-sm"
                    style={{ zIndex: 9999 }}
                    onClick={() => setShowDetails(false)}
                >
                    <div
                        className="bg-white rounded-2xl max-w-3xl w-full max-h-[85vh] overflow-hidden shadow-2xl flex flex-col"
                        onClick={(e) => e.stopPropagation()}
                    >
                        <div className="relative bg-gradient-to-br from-[#b03b8a] to-[#8a2e6b] p-8 pb-16">
                            <button
                                onClick={() => setShowDetails(false)}
                                className="absolute top-4 right-4 text-white hover:text-gray-200 text-3xl font-bold leading-none w-10 h-10 flex items-center justify-center rounded-full hover:bg-white/10 transition-colors"
                            >
                                ×
                            </button>

                            <div className="flex flex-col items-center">
                                <div
                                    className="w-[150px] h-[150px] bg-white rounded-lg shadow-lg mb-4 p-6 flex items-center justify-center"
                                >
                                    <div
                                        className="w-full h-full bg-contain bg-no-repeat bg-center"
                                        style={{ backgroundImage: `url(${thumbnail})` }}
                                    />
                                </div>

                                <h2 className="text-3xl font-proximanova font-[700] text-white text-center">
                                    {name}
                                </h2>

                                {label && (
                                    <span className="mt-3 text-[14px] text-white font-proximanova font-[700] px-4 py-1.5">
                                        {label}
                                    </span>
                                )}
                            </div>
                        </div>

                        <div className="flex-1 overflow-y-auto p-8">
                            <div className="space-y-6">
                                <div>
                                    <h3 className="text-lg font-proximanova font-[700] text-[#b03b8a] mb-2">
                                        About
                                    </h3>
                                    <p className="text-[#505050] font-proximanova leading-relaxed text-[16px]">
                                        {description}
                                    </p>
                                </div>

                                <div className="pt-4 border-t border-gray-200">
                                    <a
                                        href={website}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        className="inline-flex items-center gap-2 font-proximanova font-[700] text-[18px] text-charmOrange hover:text-[#d94f1a] transition-colors underline"
                                    >
                                        Visit Website
                                        <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M14 5l7 7m0 0l-7 7m7-7H3" />
                                        </svg>
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>,
                document.body
            )}
        </>
    );
};

export default CHICTemplate;